export default "__VITE_ASSET__CoxTVMgH__"